export const EVENTS = {
	INITIALIZE: "initialize",
	PROMOTIONBANNER: "promotion_banner",
}

export const FLOW_TYPES = {
	HOME: "home",
}
